<template>
  <div class="container">
    <div class="app-faq">
      <h1
        v-if="header"
        class="mb-45 text-center"
      >
        {{ header }}
      </h1>
      <ul class="mb-45">
        <li
          v-for="question in questionsMutable"
          :key="question.title"
          class="app-faq__item"
          :class="{
            'border-b-1 border-gray-350': border
          }"
        >
          <div
            class="app-faq__question-container"
            tabindex="0"
            @click="itemSelected(question)"
            @keypress.enter="itemSelected(question)"
          >
            <span
              class="app-faq__question"
            >
              {{ question.title }}
            </span>
            <span
              tabindex="-1"
              class="app-faq__icon"
              :class="[iconBgColor, iconTextColor]"
            >
              <font-awesome-icon
                v-if="!question.sideArrow"
                :icon="question.showAnswer ? 'angle-up' : 'angle-down'"
              />
              <font-awesome-icon
                v-else
                :icon="question.showAnswer ? 'angle-down' : 'angle-right'"
              />
            </span>
          </div>

          <!-- eslint-disable vue/no-v-html -->
          <div
            :class="{'hidden': !question.showAnswer}"
            class="app-faq__answer"
            v-html="question.answer"
          />
          <!-- eslint-enable vue/no-v-html -->
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import theme from '@/mixins/theme'

export default {
  name: 'AppFAQ',

  mixins: [
    theme
  ],

  props: {
    questions: {
      type: Array,
      required: true
    },

    header: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: ''
    },

    border: {
      type: Boolean,
      default: true
    },

    iconBackground: {
      type: Boolean,
      default: true
    },

    iconTextColor: {
      type: String,
      default: 'text-white'
    }
  },

  data () {
    return {
      questionsMutable: this.questions
    }
  },

  computed: {
    iconBgColor () {
      return this.iconBackground ? this.bgColorClass() : ''
    }
  },

  methods: {
    itemSelected (item) {
      item.showAnswer = !item.showAnswer
    }
  }
}
</script>

<style lang="scss" scoped>
.app-faq {
  @apply w-full m-auto;

  &__item {
    @apply py-20;
  }

  &__question-container {
    @apply flex justify-between items-center cursor-pointer;
  }

  &__question {
    @apply text-[15px] leading-[22px] font-semibold text-left;

    @screen sm {
      @apply text-base;
    }

    @screen lg {
      @apply text-[20px] leading-[26px];
    }
  }

  &__icon {
    @apply text-[24px] rounded-full min-w-[25px] h-25 ml-30;
    @apply flex justify-center items-center;

    svg {
      @apply align-middle h-full;
    }
  }

  &__answer {
    @apply pt-30 text-base text-left;

    :deep() p,
    :deep() ul {
      @apply mb-15;

      &:last-child {
        @apply mb-0;
      }
    }

    :deep() ul {
      @apply list-disc ml-20;
    }
  }

  &__link {
    @apply text-purple-500 text-base font-semibold;
  }
}
</style>
